import throttle from 'lodash.throttle'
import * as React from 'react'

export function useStickyShadow() {
  const stickyRef = React.useRef<HTMLDivElement>(null)
  const [isSticky, setIsSticky] = React.useState(false)

  React.useEffect(() => {
    if (!stickyRef.current) return

    const onScroll = throttle(function () {
      const stickyElement = stickyRef.current
      if (!stickyElement) return

      const elementStickyTopOffset = parseFloat(getComputedStyle(stickyElement).top)
      const elementCurrentTopOffset = stickyElement.getBoundingClientRect().top

      setIsSticky(elementCurrentTopOffset === elementStickyTopOffset)
    }, 100)

    onScroll()
    document.addEventListener('scroll', onScroll)

    return () => {
      document.removeEventListener('scroll', onScroll)
    }
  }, [])

  return React.useMemo(
    () => ({
      stickyRef,
      isSticky,
    }),
    [isSticky]
  )
}
